import { render, staticRenderFns } from "./alarm-list.vue?vue&type=template&id=6a180470&scoped=true&"
import script from "./alarm-list.vue?vue&type=script&lang=ts&"
export * from "./alarm-list.vue?vue&type=script&lang=ts&"
import style0 from "./alarm-list.vue?vue&type=style&index=0&id=6a180470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a180470",
  null
  
)

export default component.exports